import { Box, Button, Flex, Grid, Switch, Text, Textarea } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from 'src/theme/colors'
import { Delivery } from 'src/types/types'
import AdditionalServices from './AdditionalServices'
import ShippingInfo from './ShippingInfo'

export interface TrackingDetailsProps {
  data: Delivery
  onTrackDelivery: () => void
}

const TrackingDetails: React.FC<TrackingDetailsProps> = ({ data, onTrackDelivery }) => {
  const { t } = useTranslation()

  return (
    <Box
      className='shipping-box'
      borderRadius={30}
      border='1px solid'
      borderColor='gray.200'
      p={10}
      marginBottom={20}
    >
      <Grid templateColumns={{ md: 'repeat(2, 1fr)', base: 'repeat(1, 1fr)' }}>
        <Box bg='white' borderRadius='lg' p={4} position='relative'>
          <ShippingInfo title={t('common.sender')} info={data.sender} />
          <ShippingInfo title={t('common.arrivesAt')} info={data.eta} />
          <ShippingInfo title={t('common.recipient')} info={data.recipient} />
          <ShippingInfo title={t('common.address')} info={data.address} />
        </Box>

        <AdditionalServices
          onToggleLeaveAtDoor={() => {
            /* TODO: implement toggle logic */
          }}
          isLeaveAtDoorActive={true} /* replace with actual state */
        />
      </Grid>
      <Button
        variant='link'
        onClick={onTrackDelivery}
        marginLeft={4}
        color={colors.primary}
        fontSize={'xl'}
        textDecoration={'underline'}
      >
        {t('delivery.trackDelivery')}
      </Button>
    </Box>
  )
}

export default TrackingDetails
